/* eslint-disable */
import { Component } from 'react';
import { Trans } from 'Helpers';
import { Modal, ModalBody, ModalFooter } from 'reactstrap'
import {Images} from 'Helpers';

class GameOnModal extends Component {
  render() {
    const {isOpen, toggle, goToHome} = this.props
    
    
    return (
      <Modal  isOpen={isOpen} size='sm' centered className='confirmation-modal width-modal game-on'>
        {/* <div onClick={toggle} className='close-btn'>
          <i className="icon-cancel"/>
        </div> */}
        <div className='confirm-header'>
          <div className='image-wrapper'>
            <div className='image-outer'>
              <img src={Images.CONFIRM} alt="" />
            </div>
          </div>
        </div>
        <h4 className='confrim-head'>Game On!</h4>
        <ModalBody>
          <div className="game-onbody">
            Your team has been submitted successfully.
          </div>
        </ModalBody>
        <ModalFooter>
          <button onClick={()=>goToHome()} className='btn btn-join'>Go to Home</button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default GameOnModal;
